import { render, staticRenderFns } from "./OptionsCategory.vue?vue&type=template&id=7bc5d685&scoped=true"
import script from "./OptionsCategory.vue?vue&type=script&lang=js"
export * from "./OptionsCategory.vue?vue&type=script&lang=js"
import style0 from "./OptionsCategory.vue?vue&type=style&index=0&id=7bc5d685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5d685",
  null
  
)

export default component.exports